import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router';
import { usePseudoClasses } from '@helsenorge/designsystem-react/hooks/usePseudoClasses';
import { LinkContent } from './link-content';
import { useReturUrl } from './useReturUrl';
import styles from './styles.module.scss';
const Breadcrumb = (props) => {
    const { refObject: hoverRef, isHovered } = usePseudoClasses();
    const returUrl = useReturUrl();
    const href = returUrl?.returUrl || props.href;
    const text = returUrl?.returUrlTekst || props.children;
    // react-router skal ikke brukes dersom returUrl er i bruk
    const shouldRenderAsRouterLink = props.renderAsRouterLink && !returUrl;
    const renderLink = () => {
        if (shouldRenderAsRouterLink) {
            return (_jsx(Link, { to: href, className: styles.breadcrumb__link, ref: hoverRef, "data-testid": "breadcrumb-router-link", children: _jsx(LinkContent, { isHovered: isHovered, children: text }) }));
        }
        return (_jsx("a", { href: href, className: styles.breadcrumb__link, ref: hoverRef, "data-testid": "breadcrumb-link", children: _jsx(LinkContent, { isHovered: isHovered, children: text }) }));
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: styles.border }), _jsx("div", { className: 'container', children: _jsx("div", { className: 'row', children: _jsx("div", { className: 'col', children: _jsx("nav", { className: styles.breadcrumb__content, "aria-label": props.ariaLabel, children: renderLink() }) }) }) }), _jsx("div", { className: styles.border })] }));
};
export default Breadcrumb;
